import React from "react";
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Box, CardMedia, Typography, useMediaQuery, useTheme, Container, Grid, Button } from "@mui/material";
import { famineReliefData } from "../../utils/BeadsData";


const FamineRelief = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Container sx={{ mt: 12, mx: 'auto', mb: isMobile ? 2 : 8 }}>
                <Typography variant="h3" gutterBottom sx={{ my: 3, textAlign: 'center', fontWeight: 'bold' }}> Famine Relief </Typography>

                <Typography paragraph>
                    BEADS' focus is on education. But when people are starving, all other considerations are secondary. During periods of famine, BEADS does its part, buying and distributing food to the communities where we operate.
                </Typography>

                <Grid container spacing={5} justifyContent="center" sx={{ mt: 1 }}>
                    <Grid item xs={12} md={8}>
                        <Swiper
                            modules={[Autoplay, EffectFade]}
                            effect="fade"
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                            loop={true}
                            style={{ borderRadius: '2rem' }}
                        >
                            {famineReliefData.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <Box sx={{ position: 'relative', height: isMobile ? 340 : 500 }}>
                                        <img src={image.src} alt={image.alt}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        <Typography
                                            variant={isMobile ? "body2" : "subtitle1"}
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                color: 'white',
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                padding: '6px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {image.description}
                                        </Typography>
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', my: 3 }}>
                        <Box sx={{ width: '100%', py: 1, px: 1, textAlign: 'center', borderRadius: '1.5rem', background: '#f8fafd', border: '1px solid #cfcfcf' }}>
                            <Typography variant="h4" gutterBottom>
                                YouTube Documentary
                            </Typography>
                            <Typography variant="body2" paragraph>
                                This is a video clip about BEADS for Education titled; <em>Kenya Needs Famine Relief Now</em>
                            </Typography>
                            <Box
                                sx={{
                                    overflow: 'hidden',
                                    paddingTop: '56.25%',
                                    position: 'relative',
                                    iframe: {
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    },
                                }}
                            >
                                <iframe
                                    src="https://www.youtube.com/embed/cxsx9FT2FdI"
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{ borderRadius: '1.5rem' }}
                                ></iframe>
                            </Box>
                            <Typography variant="body2" paragraph sx={{ mt: 2 }}>
                                The rains have yet to come and the drought continues. This is just one family's story.
                            </Typography>

                            <Button className='btn btn-border-base' variant="outlined" onClick={() => navigate('/donate')} sx={{ mb: 2, borderRadius: 15, color: '#f39c12' }}>
                                Learn More
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Box
                sx={{
                    bgcolor: '#f8f9fc',
                    boxShadow: '3px 4px 8px rgba(0,0,0,0.1)',
                    borderRadius: '1rem',
                    my: 5,
                    mx: { xs: 2, md: 3, lg: 5 },
                    p: 3,
                    textAlign: 'center',
                    '& h5': {
                        my: 0.5,
                        fontWeight: 'bold',
                        color: 'black',
                    },
                    '& p': {
                        m: '0.8rem 0',
                    },
                }}
            >
                <Typography variant="h5" component="h5" gutterBottom>
                    **Special Post - December 2016**
                </Typography>
                <Typography variant="body1">
                    Sanaipei's sponsor family would like to request donations to help drill a borehole for clean water access. <br />
                    Sanaipei's 93-year-old father is pictured below with her mother and sponsor parents.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Please help fulfill his dream! Please donate by January 1, 2017!
                </Typography>

                <Box sx={{ width: '100%', p: 2 }}>
                    <CardMedia
                        component="img"
                        image="assets/img/f-relief/donation-request.jpeg"
                        alt="donation-request"
                        sx={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '1rem' }}
                    />
                </Box>

                <Typography variant="body1" sx={{ mt: 2, textAlign: 'left' }}>
                    November 27, 2016
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ textAlign: 'left' }}>
                    Dear mum and dad,
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ textAlign: 'left' }}>
                    This is in request to my father's plea to drill a borehole to the community and family in general. It has been my father's dream to help the community get clean water for drinking and improve food supply to his big family through farming. The other main reason is inaccessibility to safe drinking water.
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ textAlign: 'left' }}>
                    The nearest river is the one near Kimana sec school, approximately 4 hours walk with dangerous animals on the way.
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ textAlign: 'left' }}>
                    The borehole is estimated to cost Kshs 500,000 [~$5,000*] and he managed to raise 100,000 at the moment and with my support I am going to offer Kshs 50,000 for the project. <br />
                    This is his message to you and you can share with friends for any support.
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Love,
                    <br />
                    Sanaipei.
                </Typography>
                <Typography variant="body1">
                    * $1 = ~Kshs 145
                </Typography>
            </Box>

            <FooterOne />
        </Box>
    );
};

export default FamineRelief;